export default __webpack_public_path__ + "static/media/pauline-duval.4f78eb0b.jpg";